import { render } from "./Tabla.vue?vue&type=template&id=7724585c&scoped=true"
import script from "./Tabla.vue?vue&type=script&lang=js"
export * from "./Tabla.vue?vue&type=script&lang=js"

import "./Tabla.vue?vue&type=style&index=0&id=7724585c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7724585c"]])

export default __exports__